import { CircleDot, CheckCircle2, XCircle, Truck, Package, Clock } from "lucide-react";

const MAP = {
  robocze: { label: "Robocze", bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-200", Icon: CircleDot },
  do_akceptacji: { label: "Do akceptacji", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", Icon: Clock },
  odrzucone: { label: "Odrzucone", bg: "bg-red-50", text: "text-red-700", border: "border-red-200", Icon: XCircle },
  zaakceptowane: { label: "Zaakceptowane", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", Icon: CheckCircle2 },
  w_realizacji: { label: "W realizacji", bg: "bg-teal-50", text: "text-teal-700", border: "border-teal-200", Icon: Truck },
  zrealizowane: { label: "Zrealizowane", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", Icon: Package },
};

export default function StatusBadge({ status }) {
  const cfg = MAP[status] || MAP.robocze;
  const { Icon } = cfg;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`ol-badge border ${cfg.bg} ${cfg.text} ${cfg.border}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {cfg.label}
    </span>
  );
}
